import { getAmplitudeInstance } from '../amplitudeHelpers';
import DismissAction from '../enums/DismissAction';
import ProductsAvailable from '../enums/ProductsAvailable';
import PurchaseScreenTypePlan from '../enums/PurchaseScreenTypePlan';
import UpsellTrigger from '../enums/UpsellTrigger';

type logWebProModalDismissedParams = {
  dismiss_action: DismissAction;
  products_available?: ProductsAvailable;
  purchase_screen_type_plan?: PurchaseScreenTypePlan;
  trigger?: UpsellTrigger;
};

/**
 * User dismisses the upsell screen.
 * @param params - Attributes to log with the amplitude event
 * @param params.dismiss_action - The type of action the user performed to dismiss an event.
 * @param params.products_available - The combination of available products offered on an upsell (plus, plus-peak, peak).
 * @param params.purchase_screen_type_plan - The purchase type shown for the default product selected on the upsell (e.g. trial, non-trial, promo, special peak promo).
 * @param params.trigger - Action that triggered the upsell to display
 */
const logWebProModalDismissed = (
  { dismiss_action, products_available, purchase_screen_type_plan, trigger }: logWebProModalDismissedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'web pro modal dismissed',
    { 'dismiss action': dismiss_action, 'products available': products_available, 'purchase screen type plan': purchase_screen_type_plan, trigger },
    callback
  );
};

export default logWebProModalDismissed;
